import { type IGenericResponseRoot } from '../../utils/getErrorData';
import { type IProduct } from '../../types/IProduct';
import { api } from '../../utils/api';
import { type IProductByArticulResponse } from '../../types/IProductByArticulResponse';

// Поиск товара по артиклю
export const searchProductByArticle = async (
  vendorCode: string
): Promise<IProduct[]> => {
  const url = '/admin/products/search/by-article';
  const { data } = await api.get<
    IGenericResponseRoot<IProductByArticulResponse>
  >(url, {
    params: { limit: 10, article: vendorCode }
  });

  if (data.response === null || !Array.isArray(data.response.items)) {
    throw new Error('Некорректный ответ от сервера');
  }

  return data.response.items;
};
